__turbopack_context__.v({
  "dark": "Tab-module-scss-module__QprFDa__dark",
  "fill": "Tab-module-scss-module__QprFDa__fill",
  "fill_dark": "Tab-module-scss-module__QprFDa__fill_dark",
  "fill_gray": "Tab-module-scss-module__QprFDa__fill_gray",
  "fill_primary": "Tab-module-scss-module__QprFDa__fill_primary",
  "gray": "Tab-module-scss-module__QprFDa__gray",
  "lg": "Tab-module-scss-module__QprFDa__lg",
  "line": "Tab-module-scss-module__QprFDa__line",
  "line_dark": "Tab-module-scss-module__QprFDa__line_dark",
  "line_gray": "Tab-module-scss-module__QprFDa__line_gray",
  "line_primary": "Tab-module-scss-module__QprFDa__line_primary",
  "md": "Tab-module-scss-module__QprFDa__md",
  "primary": "Tab-module-scss-module__QprFDa__primary",
  "sm": "Tab-module-scss-module__QprFDa__sm",
  "tab": "Tab-module-scss-module__QprFDa__tab",
  "white": "Tab-module-scss-module__QprFDa__white",
  "wrap": "Tab-module-scss-module__QprFDa__wrap",
});
